// gatsby-plugin-prismic-previews only registers onClientEntry itself; the provider that holds
// preview state has to be mounted by the site.
import {
  narrowPreviewBootstrapToDocument,
  persistPreviewTokenFromUrl,
  wrapRootElement as wrapWithPreviews,
} from './src/utils/prismicPreviews';
import { wrapRootElement as wrapWithRegion } from './src/utils/region';
import { captureAttribution, installSignUpLinkDecorator } from './src/utils/attribution';
import { subscribe as subscribeToConsent } from './src/utils/consent';
import { syncPixelWithConsent, trackCustom, trackPageView } from './src/utils/metaPixel';

// The region provider goes inside the preview provider: it re-mounts the page when the visitor's
// region resolves, and an active preview session has to survive that.
export const wrapRootElement = ({ element }) => wrapWithPreviews({
  element: wrapWithRegion({ element }),
});

// Gatsby awaits this before rendering, so the preview ref is in place by the time the plugin's
// resolver and page HOCs look for it.
export const onClientEntry = () => {
  persistPreviewTokenFromUrl();
  narrowPreviewBootstrapToDocument();

  // Read the landing URL's UTM tags before anything can navigate away from it.
  captureAttribution(window.location.search);

  // A custom event rather than Lead: a click on Start Free is intent, not a completed signup,
  // and signups are counted in the app against UTMs. No-op unless Advertising is allowed.
  installSignUpLinkDecorator({
    onSignUpClick: () => trackCustom('SignUpClick', { page: window.location.pathname }),
  });

  // Loads the Meta Pixel for a returning visitor who has already allowed Advertising, and on any
  // later grant or withdrawal. No-op off www.careerskitchen.com unless GATSBY_META_PIXEL_ID is set.
  syncPixelWithConsent();
  subscribeToConsent(syncPixelWithConsent);
};

export const onRouteUpdate = ({ location }) => {
  captureAttribution(location.search);
  trackPageView(location.pathname);
};
